import * as React from "react";
const LocalPresenceSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={56}
    height={56}
    fill="none"
    {...props}
  >
    <rect width={48} height={48} x={4} y={4} fill="#fff" rx={24} />
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      stroke="#DFE2EB"
      strokeWidth={8}
      rx={24}
    />
    <path
      fill="#2C2F38"
      d="M40.25 33.876h-.875V20.084l1.058-.228a.874.874 0 1 0-.367-1.71l-24.5 5.25a.874.874 0 0 0 .369 1.71l.69-.148v8.918h-.875a.875.875 0 1 0 0 1.75h24.5a.875.875 0 1 0 0-1.75Zm-21.875-9.297 19.25-4.12v13.417H35V27.75a.875.875 0 0 0-.875-.875h-12.25a.875.875 0 0 0-.875.875v6.125h-2.625v-9.297Zm14.875 5.797h-10.5v-1.75h10.5v1.75Zm-10.5 1.75h10.5v1.75h-10.5v-1.75Z"
    />
  </svg>
);
export default LocalPresenceSVG;
